import { render, staticRenderFns } from "./QuarantinePosition.vue?vue&type=template&id=6367d279&scoped=true&"
import script from "./QuarantinePosition.vue?vue&type=script&lang=js&"
export * from "./QuarantinePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367d279",
  null
  
)

export default component.exports